import React, { useState } from 'react';
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';

import AccountCircle from '@material-ui/icons/AccountCircle';
import { RootState } from '../../store';
import { actions } from '../../services/auth';



const AdminUserActions: React.FC = () => {
  const [ anchorEl, setAnchorEl ] = useState(null);
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.auth.user);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSignOut = () => {
    handleClose();
    dispatch(actions.signOut());
  }


  return (
    <div>
      <IconButton
        size="large"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem disabled>
          {user?.name}
        </MenuItem>
        <Divider />
        <MenuItem onClick={onSignOut}>Sign Out</MenuItem>
      </Menu>
    </div>
  )
}

export default AdminUserActions;